import { useContext, useEffect } from 'react';

import type { ErrorTracking } from '@sorare/wallet-shared';
import { MessagingContext } from '@sorare/wallet-shared';

import { sendSafeError } from '#src/lib/error.ts';

export function useErrorEvent() {
  const { registerHandler } = useContext(MessagingContext)!;

  useEffect(
    () =>
      registerHandler<ErrorTracking>('errorTracking', async error => {
        sendSafeError(error);
        return {};
      }),
    [registerHandler]
  );
}
